import RoutesMap from "../../route_control/RouteControl"
import { VendorList, VendorDetails, VendorServiceList } from "../../pages/vendor"

export const VendorRouteImport = {
    RoutesMap,
    VendorList,
    VendorDetails,
    VendorServiceList
}